<template>
  <gh-date-picker v-if="!readonly" v-model="model[`${prop.value}`]" :label="prop.text"></gh-date-picker>
  <v-text-field v-else readonly v-model="Value" :label="prop.text" :id="prop.value" :color="prop.color"></v-text-field>
</template>

<style scoped>

</style>

<script>
  import DateInpute from "./dateInpute.ts";
  export default DateInpute;
</script>